import React from 'react'

interface CommunicationLetterIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string
  size?: number
}

const CommunicationLetterIcon: React.FC<CommunicationLetterIconProps> = ({
  color = 'currentColor',
  size = 24,
  ...props
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <path
        d='M7.02148 19.0234C7.02148 19.3115 6.91191 19.5312 6.75781 19.6709C6.74724 19.6805 6.73672 19.6902 6.72656 19.7002C6.55832 19.8666 6.32062 19.9821 6.03125 19.999C5.51154 20.0241 5 19.5586 5 18.9307L5.01465 17L7.02148 17L7.02148 19.0234ZM9.02148 16C9.02148 15.4477 8.57377 15 8.02148 15L4.02148 15C3.47244 15.0002 3.02577 15.4431 3.02148 15.9922L3 18.9238L3 18.9307C3 20.5316 4.27308 21.997 5.97656 22L6.14258 21.9961L6.14746 21.9951C6.90243 21.9511 7.58545 21.6444 8.09961 21.1504L8.10156 21.1523C8.6957 20.6136 9.02148 19.8456 9.02148 19.0234L9.02148 16Z'
        fill={color}
      />
      <path
        d='M20 2C20.5522 2.00008 21 2.44776 21 3V18C21 20.2091 19.2091 21.9999 17 22H6V21C6.03142 20.9997 6.06299 20.9983 6.09473 20.9961C6.65951 20.9541 7.15799 20.6601 7.52344 20.1982C7.92194 19.7365 8.15422 19.0651 8.1543 18.3096V16H7.07129V3C7.07129 2.44776 7.51907 2.00008 8.07129 2H20ZM10.7871 10C10.3524 10 10 10.4477 10 11C10 11.5523 10.3524 12 10.7871 12H16.2129C16.6476 12 17 11.5523 17 11C17 10.4477 16.6476 10 16.2129 10H10.7871ZM10.8877 6C10.3554 6.00008 9.92383 6.44776 9.92383 7C9.92383 7.55224 10.3554 7.99992 10.8877 8H17.5313C18.0635 7.99994 18.4951 7.55225 18.4951 7C18.4951 6.44775 18.0635 6.00006 17.5313 6H10.8877Z'
        fill={color}
      />
    </svg>
  )
}

export default CommunicationLetterIcon
